import { Component, inject } from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-page-not-found',
    template: `
        <div class="text-center">
            <h2>404</h2>
            Seite nicht gefunden<br>
            <button type="button" class="btn btn-primary mt-2" (click)="dashboard()">Zum Dashboard</button>
        </div>
    `
})
export class PageNotFoundComponent {

    private router = inject(Router);

    dashboard(): void {
        this.router.navigate(['/']);
    }

}
